export default __webpack_public_path__ + "static/media/logo-albo.519df49f.svg";